import http from '@/utils/http' //引入axios
export const getVersion = data => http.get('/rvm-center/api/version', {
    params: data
}) //查找版本
export const updataVersion = data => http.put('/rvm-center/api/version', data) //編輯版本
export const addVersion = data => http.post('/rvm-center/api/version', data) //添加版本
export const deleteVersion = data => http.delete('/rvm-center/api/version', {
    params: data
}) //根据id刪除版本
// export  const findVersion = data=>http.get('/api/district/superior',{params:data}) //查找部门
export default {
    getVersion,
    updataVersion,
    addVersion,
    deleteVersion,
    // findVersion
}